import { useEffect, useState } from "react";
import Accordion from "./accordian";
import TaskCard from "./taskCard";
import { getTaskTemplate, saveTaskTemplate } from "../../utils/firebasefunctions";

function MainTaskTemplate() {
  const [tasks, setTasks] = useState({});
  const [editingTaskId, setEditingTaskId] = useState(null);
  const STATUSES = [
    "Prospect",
    "On Hold",
    "CMAs",
    "Listing Appointment",
    "Pre-Market",
    "Coming Soon",
    "Active",
    "Under Contract",
    "Pending",
    "Closed",
    "Cancelled",
    "Expired",
  ];

  const addNewTask = async (status) => {
    const newTask = {
      id: Date.now(),
      title: "",
      assignee: null,
      deadline: "",
      image: null,
      createdAt: new Date(),
    };

    const updatedTasks = {
      ...tasks,
      [status]: [newTask, ...(tasks[status] || [])],
    };

    setTasks(updatedTasks);
    setEditingTaskId(newTask.id);

    await saveTaskTemplate(updatedTasks);
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log('data', data)
    };

    fetchData();
  }, []);

  return (
    <div>
      {/* <header className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left px-10 py-7 lg:py-5 border-b border-black/10 bg-white">
        <div className="page-title">
          <h2 className="text-3xl sm:text-4xl font-bold bg-[#1E293B] bg-clip-text text-transparent">
            Task Template
          </h2>
        </div>
      </header> */}
      <div className="rounded-lg">
        {STATUSES.map((status) => {
          const statusTasks = tasks[status] || [];

          return (
            <Accordion
              key={status}
              title={status}
              count={statusTasks.length}
              onAdd={() => addNewTask(status)}
            >
              {/* HEADER */}
              <div className="justify-between w-full text-sm items-center flex">
                <div className="w-[45%] lg:w-[45%] ml-2">Task Name</div>
                <div className="w-[15%] lg:w-[20%] text-center">Assign</div>
                <div className="w-[25%] lg:w-[20%] text-center">
                  Attachments
                </div>
                <div className="w-[10%] lg:w-[15%] text-center mr-3 md:mr-0">Action</div>
              </div>

              {/* TASK LIST */}
              {statusTasks.length === 0 ? (
                <p className="text-sm text-gray-400 text-center py-3">
                  No tasks
                </p>
              ) : (
                statusTasks.map((task) => (
                  <TaskCard
                    key={task.id}
                    task={task}
                    tasks={tasks}
                    setTasks={setTasks}
                    status={status} // 🔥 IMPORTANT
                    editingTaskId={editingTaskId}
                    setEditingTaskId={setEditingTaskId}
                  />
                ))
              )}
            </Accordion>
          );
        })}
      </div>
    </div>
  );
}

export default MainTaskTemplate;
